<!--
- 投融资总趋势 地域分布
- 作者：王尧
- 修改时间：2019-12-10
- 图表点击交互模式修改，代码优化
 -->
<template>
<div class="financing_data">
  <div class="chart_bg">
    <div class="title">
      <span class="chart_name">地域分布（{{params.unit_type | deal('unit')}}）</span>
      <div class="condition">
        <div class="change-unit">
          <Dropdown @on-click="handleChangeUnit">
            <a href="javascript:void(0)">{{params.unit_type | deal('unit')}}</a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in unit_list" :name="item.id" :key="item.id" :disabled="item.id == params.unit_type">{{ item.name }}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="location">
          <AddressTab @selectAddress="addressChecked"></AddressTab>
        </div>
        <!-- <div class="upload">
            <a @click="haddleSave"><i class="iconfont">&#xe644;</i>下载</a>
        </div> -->
      </div>
    </div>
    <div id="up_img">
      <Spin fix v-if="spinShow2">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      <div :class="{'all': true, 'show': spinShow2}" v-show="params.demostic === ''">
        <div class="chart" id="chart" :key="page_title + name"></div>
      </div>
      <div :class="{'ch_data': true, 'show': spinShow2}" v-show="params.demostic == '1'">
        <p class="map_tip">国内分布</p>
        <div class="clear">
          <div class="map_table">
            <Table :columns="map_columns" :data="map_list"></Table>
          </div>
          <div class="chart" id="chart6"></div>
        </div>
      </div>
      <div :class="{'hw_data': true, 'show': spinShow2}" v-show="params.demostic == '0'">
        <p class="map_tip">国外分布</p>
        <div class="hw_chart clear">
          <div class="hw_li">
            <p class="chart_name">事件数（数量）</p>
            <div class="chart" id="chart7"></div>
          </div>
          <div class="hw_li">
            <p class="chart_name">融资额（亿{{params.unit_type | deal('unit')}}）</p>
            <div class="chart" id="chart8"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="time_slier">
      <Slider v-model="years" range :min="2011" :step="0.01" :tip-format="sliderTipFormat" :max="moment_year" @on-change="hadleTimeSlider" class="year_slider" show-tip="never"></Slider>
      <div style="slier_axis" class="slier_axis">
        <span v-for="item,index in slier_axis" :key="item"  :style="'left:' + (100 / (slier_axis.length - 1)) * index + '%'">{{item}}</span>
      </div>
    </div>
    <p class="data_src"><span>数据来源：动脉橙数据库</span><span>数据截止时间：{{today}}</span></p>
  </div>
  <div class="top-tip">全部<span>（{{total}}）</span>
    <Dropdown @on-click="haddleChangeSort">
      <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
      <DropdownMenu slot="list">
        <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
  <div class="list_div">
    <Table :columns="columns" :data="list"></Table>
    <div class="page clear" v-if="total > 10">
      <Page :total="total" :page-size="10" :current="list_params.page" class="page_list" show-total show-elevator @on-change="handleChangePage" ref="pages" />
    </div>
  </div>
  <Contanct></Contanct>
  <DownloadCharts v-if="visible" :visible="visible" :imgbase="imgbase" :tabTitle="name" :pageTitle="page_title" :params="params" @closeecharts="closeEcharts"></DownloadCharts>
  <Spin fix v-if="spinShow">
    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
    <div>Loading</div>
  </Spin>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import AddressTab from '../AddressTab'
import DownloadCharts from '../DownloadCharts2'
import {
  financing_common
} from 'js/financing_mixins'
import echarts from 'echarts'
import {
  option2,
  option5,
  option6,
  option7
} from 'js/financing_chart'
import {
  trendMapCountry, trendCountryOfEventList
} from '../../../../service'
import moment from 'moment'
import html2canvas from 'html2canvas'

export default {
  mixins: [financing_common],
  components: {
    Contanct,
    AddressTab,
    DownloadCharts
  },
  data() {
    const _this = this
    return {
      page_title: '投融资总趋势',
      name: '地域分布',
      map_option: option2,
      list: [],
      list_params: {
        user_key: this.$store.state.user_key,
        page: 1,
        sort_type: 0,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY'))
      },
      params: {
        user_key: this.$store.state.user_key,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        unit_type: 3,
        a_type: 2
      },
      map_list: [],
      map_columns: [{
          title: '地区',
          width: 85,
          render: (h, params) => {
            return h('span', filter.empty(params.row.name))
          }
        },
        {
          title: '融资事件',
          width: 110,
          render: (h, params) => {
            return h('span', filter.empty(params.row.value) + '起')
          }
        },
        {
          title: '融资额',
          minWidth: 85,
          render: (h, params) => {
            return h('span', params.row.amount_n)
          }
        }
      ],
      even_option: option5,
      a_option: option6,
      option: option7,
      spinShow2: false,
      all_chart: '',
      f_chart_e: '',
      f_chart_a: '',
      c_chart: ''
    }
  },
  computed: {
    address() {
      return this.$store.state.address
    }
  },
  methods: {
    async getMap() {
      this.curInt = ''
      this.params.a_type = this.params.demostic == '' ? 2 : this.params.demostic
      this.params.other_address = []
      this.spinShow2 = true
      let res = await trendMapCountry(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if (this.is_destroyed) {
          return false
        }
        this.echartChangeTheme3()
        if (this.params.a_type == 2) {
          let all_data_x = [], all_data_y1 = [], all_data_y2 = []
          res.res.map((item,index) => {
            if (index < 9) {
              all_data_y1.push(filter.amountFilter(item.total_amount))
              all_data_y2.push(item.event_count)
              all_data_x.push(item.address_id)
            } else if (index == 9) {
              all_data_y1.push(filter.amountFilter(item.total_amount))
              all_data_y2.push(Number(item.event_count))
              all_data_x.push('其他')
            } else {
              all_data_y1[9] += filter.amountFilter(item.total_amount)
              all_data_y1[9] = Math.round(all_data_y1[9] * 100) / 100
              all_data_y2[9] += Number(item.event_count)
            }
          })
          // // 全球 融资金额和事件
          this.option.legend.data = ['融资额' + '|' + this.params.unit_type, '事件数']
          this.option.series[0].name = '融资额' + '|' + this.params.unit_type
          this.option.series[1].name = '事件数'
          this.option.xAxis[0].axisLabel.rotate = 0
          this.option.xAxis[0].data = all_data_x
          this.option.series[0].data = all_data_y1
          this.option.series[1].data = all_data_y2
          this.all_chart.setOption(this.option)
          this.all_chart.off('click')
          this.all_chart.on('click', (params) => {
            if (this.curInt === params.dataIndex) {
              this.curInt = ''
              this.list_params.demostic = ''
              this.list_params.address_id = ''
              this.list_params.other_address = []
            } else {
              if (params.name === '其他') {
                this.list_params.demostic = 0
                this.list_params.address_id = ''
                this.list_params.other_address = all_data_x.slice(0, 9)
              } else {
                this.list_params.demostic = 1
                this.list_params.address_id = params.name
                this.list_params.other_address = []
              }
              this.curInt = params.dataIndex
            }
            this.list_params.page = 1
            this.getList()
            this.all_chart.setOption(this.option)
          });
        } else if (this.params.a_type == 1) {
          let data_ch_map = []
          res.res.map((item,index) => {
            data_ch_map.push({
              name: filter.deal(item.address_id, 'address'),
              value: item.event_count,
              amount: filter.amountFilter(item.total_amount),
              amount_n: filter.amountFilter(item.total_amount) + '亿' + filter.deal(this.params.unit_type, 'unit')
            })
          })

          this.$set(this.$data, 'map_list', data_ch_map.slice(0, 10))

          // 中国地图
          this.map_option.series[0].data = data_ch_map
          if (data_ch_map.length > 0) {
            this.map_option.visualMap.max = data_ch_map[0].value
          }
          this.c_chart.setOption(this.map_option)
        } else if (this.params.a_type == 0) {
          let f_amount = [], f_event = [], x_add_a = []
          res.res.map((item,index) => {
            if (index < 4) {
              f_amount.push({
                name: filter.deal(item.address_id, 'address'),
                value: filter.amountFilter(item.total_amount)
              })
              f_event.push({
                name: filter.deal(item.address_id, 'address'),
                value: item.event_count
              })
              x_add_a.push(filter.deal(item.address_id, 'address'))
            } else if (index == 4) {
              f_amount.push({
                name: '其他',
                value: filter.amountFilter(item.total_amount)
              })
              f_event.push({
                name: '其他',
                value: Number(item.event_count)
              })
              x_add_a.push('其他')
            } else {
              f_amount[4].value += filter.amountFilter(item.total_amount)
              f_amount[4].value = Math.round(f_amount[4].value * 100) / 100
              f_event[4].value += Number(item.event_count)
              f_event[4].value = Math.round(f_event[4].value * 100) / 100
            }
          })
          // // 国外 事件数
          this.even_option.legend.data = x_add_a
          this.even_option.series[0].name = '事件数'
          this.even_option.series[0].data = f_event
          this.f_chart_e.setOption(this.even_option)
          // // 国外 融资金额
          this.a_option.legend.data = x_add_a
          this.a_option.series[0].name = '融资额' + '|' + this.params.unit_type
          this.a_option.series[0].data = f_amount
          this.f_chart_a.setOption(this.a_option)
        }
        this.spinShow = false
        this.spinShow2 = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    convertData(data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          });
        }
      }
      return res
    },
    haddleChangeTime() {
      this.getMap()
    },
    haddleSave() {
      _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '下载点击'])
      this.loginVipFlow(() => {
        html2canvas(document.getElementById('up_img'), {
          scale: 1,
          backgroundColor: !this.theme_switch ? '#2A2F42' : '#ffffff',
          useCORS: true,
          tainttest: true
        }).then((canvas) => { // canvas是个dom对象
          let save_url = canvas.toDataURL("image/png")
          this.imgbase = save_url
          this.visible = true
        })
      })
    },
    async getList() {
      let res = await trendCountryOfEventList(this.list_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        // 列表数据
        this.$set(this.$data, 'list', res.res)
        if (this.list_params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
      } else {
        this.$Message.error(res.msg)
      }
    }
  },
  mounted() {
    const _this = this
    this.option.series[0].itemStyle.normal.color = function(params) {
      let color_stops = params.dataIndex === _this.curInt ? [{offset: 0,color: '#2f91a6'}, {offset: 1,color: '#2e76ad'}] : [{offset: 0,color: '#30D3EF'}, {offset: 1,color: '#31A8FD'}]
      return {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: color_stops
      }
    }
    this.option.xAxis[0].axisLabel.formatter = function(value) {
      if (value === '其他') {
        return value
      } else {
        return filter.deal(value, 'address')
      }
    }
    this.option.series[1].symbolSize = function(item, params) {
      return params.dataIndex !== _this.curInt ? 4 : 8
    }

    this.c_chart = echarts.init(document.getElementById('chart6'), 'macarons')
    this.f_chart_e = echarts.init(document.getElementById('chart7'), 'macarons')
    this.f_chart_a = echarts.init(document.getElementById('chart8'), 'macarons')
    this.all_chart = echarts.init(document.getElementById('chart'))

    this.getMap()
    this.getList()
  },
  destroyed() {
    this.option = ''
    this.map_option = ''
    this.even_option = ''
    this.a_option = ''
    this.mychart = ''
  },
  watch: {
    theme_switch(val) {
      if (!this.spinShow) {
        this.echartChangeTheme3()
        this.all_chart.setOption(this.option, true)
        this.f_chart_e.setOption(this.even_option, true)
        this.f_chart_a.setOption(this.a_option, true)
        this.c_chart.setOption(this.map_option, true)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
.financing_data
  .chart_bg
    .map_tip
      font-size: 14px
      font-weight: bold
      color: #bcbdc1
      commonColor(#bcbdc1, #999999)
      padding: 20px 0 20px 30px
    .ch_data
      .map_table
        float: left
        width: 330px
        height: 480px
        margin: 0 30px
        & >>> .ivu-table-wrapper
          .ivu-table
            commonBgColor(#323646, #FFFFFF)
            .ivu-table-row-hover
              box-shadow: none
            .ivu-table-header
              commonBgColor(#1F2330, #FFFAF5)
            th
              height: 44px
              border-right: 1px solid
              commonBgColor(#1F2330, #FFFAF5)
              commonColor(#BCBDC1, #333333)
              commonBorderColor(#414556, #F3F3F3)
              font-size: bold
              .ivu-table-cell
                commonColor(#BCBDC1, #333333)
                font-weight: normal
              &:last-child
                border-right: 0
            td
              padding: 6px 0
              height: 42px
              font-size: 12px
              border-right: 1px solid
              commonBorderColor(#414556, #F3F3F3)
              .ivu-table-cell
                commonColor(#E9E9EB, #666666)
              &:last-child
                border-right: 0
            .ivu-table-cell
              font-size: 12px
              padding-left: 10px !important
            .ivu-table-body
              tr:last-of-type
                td
                  border-bottom: 0
      .chart
        width: 750px
        height: 480px
        margin: 0
        float: left
    .hw_data
      .hw_chart
        .hw_li
          float: left
          width: 50%
          .chart_name
            font-size: 14px
            color: #797b83
            margin-left: 30px
            font-weight: bold
          .chart
            height: 160px
            width: 510px
#up_img
  position: relative
  .ivu-spin-fix
    commonBgColor(#2a2f42, #FFFFFF)
.show
  opacity: 0
</style>
